"use client";

import * as React from "react";

export function AnimatedTextCycle({ words, interval = 2200, className = "" }) {
  const safeWords = Array.isArray(words) && words.length ? words : [""];
  const [index, setIndex] = React.useState(0);
  const [width, setWidth] = React.useState("auto");
  const [phase, setPhase] = React.useState("enter");
  const measureRef = React.useRef(null);
  const activeWord = safeWords[index] || "";

  React.useEffect(() => {
    if (!safeWords.length) return undefined;

    const timer = window.setInterval(() => {
      setPhase("exit");

      window.setTimeout(() => {
        setIndex((current) => (current + 1) % safeWords.length);
        setPhase("enter");
      }, 280);
    }, interval);

    return () => window.clearInterval(timer);
  }, [interval, safeWords.length]);

  React.useLayoutEffect(() => {
    if (!measureRef.current) return;

    const nextWidth = measureRef.current.offsetWidth;
    if (nextWidth > 0) {
      setWidth(`${nextWidth}px`);
    }
  }, [activeWord]);

  return (
    <span
      className={`animated-text-cycle ${className}`.trim()}
      style={{ width }}
    >
      <span ref={measureRef} className="animated-text-cycle-measure">
        {activeWord}
      </span>
      <span className={`animated-text-cycle-word is-${phase}`}>
        {activeWord}
      </span>
    </span>
  );
}
